/* Browser preferences only. Never writes sale_of_data or subscribes an email. */
(() => {
  'use strict';
  if (window.PawPrivacy) return;
  const keys = ['analytics', 'marketing', 'preferences'];
  const methods = {analytics:'analyticsProcessingAllowed', marketing:'marketingAllowed', preferences:'preferencesProcessingAllowed'};
  let loading, announced = false;
  const api = () => window.Shopify?.customerPrivacy;
  const usable = () => typeof api()?.currentVisitorConsent === 'function' && typeof api()?.setTrackingConsent === 'function';
  function snapshot() {
    if (!usable()) return null;
    const privacy = api();
    return {
      analyticsAllowed: privacy.analyticsProcessingAllowed?.() === true,
      marketingAllowed: privacy.marketingAllowed?.() === true,
      preferencesAllowed: privacy.preferencesProcessingAllowed?.() === true,
      saleOfDataAllowed: privacy.saleOfDataAllowed?.() === true
    };
  }
  function announce() {
    if (announced) return;
    announced = true;
    // Local integration event, deliberately distinct from Shopify's event.
    document.dispatchEvent(new CustomEvent('shopifyCustomerPrivacyApiLoaded', {detail:snapshot()}));
  }
  function load() {
    if (usable()) { announce(); return Promise.resolve(api()); }
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      let settled = false, retry;
      const finish = error => {
        if (settled) return;
        settled = true; clearTimeout(timer); clearTimeout(retry);
        if (error || !usable()) reject(new Error('Cookie preferences unavailable'));
        else { announce(); resolve(api()); }
      };
      const timer = setTimeout(() => finish(true), 10000);
      function attempt() {
        if (settled) return;
        if (usable()) return finish();
        if (typeof window.Shopify?.loadFeatures === 'function') {
          try { window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], finish); }
          catch { finish(true); }
        } else if (!window.Shopify?.shop) finish(true);
        else retry = setTimeout(attempt, 100);
      }
      attempt();
    }).finally(() => { loading = null; });
    return loading;
  }
  // Consumers can inspect permissions when loaded after the one-time event.
  window.PawPrivacy = Object.freeze({load, snapshot});
  load().catch(() => {});

  const dialog = document.getElementById('pc-cookie-dialog');
  if (!dialog) return;
  const status = document.getElementById('pc-cookie-status');
  const fields = document.getElementById('pc-cookie-fields');
  const saveButton = document.getElementById('pc-cookie-save');
  const rejectButton = document.getElementById('pc-cookie-reject');
  const retryButton = document.getElementById('pc-cookie-retry');
  const controls = Object.fromEntries(keys.map(key => [key, fields.querySelector('input[name="'+key+'"]')]));
  let opener, busy = false, opening = 0;
  function lock(value) { fields.disabled = value; saveButton.disabled = value; rejectButton.disabled = value; }
  function say(text, state) { status.textContent = text; status.dataset.state = state; }
  function readChoices() {
    const privacy = api(), current = privacy.currentVisitorConsent();
    for (const key of keys) {
      // Empty means not yet explicitly chosen; show Shopify's effective state.
      controls[key].checked = current[key] === 'yes' || (current[key] !== 'no' && privacy[methods[key]]?.() === true);
    }
  }
  function failed() {
    lock(!usable()); retryButton.hidden = false;
    say('We could not confirm your cookie preferences. Try again, or contact us from our Privacy Policy.', 'error');
  }
  async function open(button) {
    if (busy) return;
    opener = button || opener;
    const serial = ++opening;
    if (!dialog.open) dialog.showModal();
    lock(true); retryButton.hidden = true;
    say('Loading your current cookie preferences…', 'loading');
    try {
      await load();
      if (serial !== opening || !dialog.open) return;
      readChoices(); lock(false);
      say('Your current preferences are shown. Change them and save whenever you wish.', 'ready');
    } catch { if (serial === opening && dialog.open) failed(); }
  }
  async function save(rejectAll = false) {
    if (busy) return;
    busy = true; lock(true); retryButton.hidden = true;
    const desired = Object.fromEntries(keys.map(key => [key, rejectAll ? false : controls[key].checked]));
    say('Saving your cookie preferences…', 'saving');
    try {
      const privacy = await load();
      await new Promise((resolve, reject) => {
        let settled = false;
        const finish = error => { if (settled) return; settled = true; clearTimeout(timer); error ? reject(new Error('Choice not confirmed')) : resolve(); };
        const timer = setTimeout(() => finish(true), 10000);
        try {
          privacy.setTrackingConsent(desired, result => {
            if (result?.error) return finish(true);
            try {
              const current = privacy.currentVisitorConsent();
              finish(!keys.every(key => current[key] === (desired[key] ? 'yes' : 'no')));
            } catch { finish(true); }
          });
        } catch { finish(true); }
      });
      readChoices(); lock(false);
      say(rejectAll ? 'Non-essential cookies are rejected for this browser and device.' : 'Your cookie preferences are saved for this browser and device.', 'saved');
    } catch { failed(); }
    finally { busy = false; }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-pc-cookie-settings]');
    if (button) { event.preventDefault(); open(button); }
  });
  dialog.querySelector('[data-pc-cookie-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('cancel', event => { event.preventDefault(); event.stopPropagation(); dialog.close(); });
  dialog.addEventListener('close', () => { opening++; opener?.focus({preventScroll:true}); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
  saveButton.addEventListener('click', () => save());
  rejectButton.addEventListener('click', () => save(true));
  retryButton.addEventListener('click', () => open(opener));
  document.addEventListener('visitorConsentCollected', () => {
    if (dialog.open && !busy && usable()) {
      readChoices(); lock(false); retryButton.hidden = true;
      say('Your current cookie preferences have been updated.', 'ready');
    }
  });
})();
